/* eslint-disable max-classes-per-file */
import {
  extendObservable,
  observable,
  action,
  reaction,
  autorun,
  computed,
} from 'mobx';

class ParameterSubStore {
  constructor(getValueFunction) {
    extendObservable(
      this,
      {
        get value() {
          return getValueFunction();
        },
      },
      {
        value: computed,
      },
    );
  }
}

class ParameterStore {
  constructor() {
    this.stores = {};
    this.parameters = {};
    extendObservable(
      this,
      {
        stores: this.stores,
        parameters: this.parameters,
        registerSubstore: this.registerSubstore,
      },
      { stores: observable, parameters: observable, registerSubstore: action },
    );
  }

  registerStore(store, storeName, subStoreName, valueName) {
    this.stores[storeName] = store;
    const keys = Object.keys(store[subStoreName]);
    keys.forEach((k) => {
      this.registerSubstore(store[subStoreName][k], valueName, k);
    });
  }

  registerSubstore(store, valueName, key) {
    this.parameters[key] = new ParameterSubStore(() => {
      return store[valueName];
    });
    // extendObservable(this, { [key]: this[key] }, { [key]: observable });
  }
}
export default new ParameterStore();
